import Distance from './Distance';

const routes = [

  { path: 'distance', element: <Distance />},

]

  export default routes;